// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ABCWhyteInktrap-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../icons/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "WhyteInktrap";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
* {
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

html, body {
  color: #222228;
}

.MultiSelect_wrapper__cD0am {
  position: relative;
  display: flex;
  align-items: center;
}
.MultiSelect_wrapper__cD0am .MultiSelect_button__jBTWA {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 10px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #EAECF0;
  cursor: pointer;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  font-size: 14px;
  max-width: 500px;
}
.MultiSelect_wrapper__cD0am .MultiSelect_button__jBTWA .MultiSelect_crossIconWrapper__AjxRY:after {
  display: flex;
  cursor: pointer;
  background-color: #60748E;
  color: #fff;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  padding: 2px;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  vertical-align: middle;
  content: "×";
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}
.MultiSelect_wrapper__cD0am .MultiSelect_button__jBTWA .MultiSelect_downArrowIcon__7bQgZ {
  height: 20px;
  width: 20px;
}
.MultiSelect_wrapper__cD0am .MultiSelect_options__mvZTK {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 100%;
  left: 0;
  margin-top: 10px;
  padding: 10px;
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #EAECF0;
  max-height: 200px;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1 1;
  min-width: 400px;
}
.MultiSelect_wrapper__cD0am .MultiSelect_options__mvZTK .MultiSelect_option__JiksJ {
  line-height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.MultiSelect_wrapper__cD0am .MultiSelect_options__mvZTK .MultiSelect_option__JiksJ .MultiSelect_checkbox__eI1VO {
  height: 24px;
  width: 24px;
  border: 1px solid #EAECF0;
  border-radius: 6px;
  flex-shrink: 0;
}
.MultiSelect_wrapper__cD0am .MultiSelect_options__mvZTK .MultiSelect_option__JiksJ .MultiSelect_checkbox__eI1VO.MultiSelect_active__kKJe1 {
  background-color: #60748E;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 9px;
}
.MultiSelect_wrapper__cD0am .MultiSelect_options__mvZTK .MultiSelect_option__JiksJ:hover {
  border-radius: 8px;
  background-color: #DDEAFB;
}`, "",{"version":3,"sources":["webpack://./src/components/MultiSelect/MultiSelect.module.scss","webpack://./src/core/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,2BAAA;EACA,+DAAA;ADEF;ACyBA;EACE,sBAAA;EACA,gCAzBS;ADEX;;AC0BA;EACE,cAVY;ADbd;;AAVA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAaF;AAXE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAaJ;AAXI;EACE,aAAA;EACA,eAAA;EACA,yBCdK;EDeL,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAaN;AAVI;EACE,YAAA;EACA,WAAA;AAYN;AARE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,mBC9BI;ED+BJ,kBAAA;EACA,4CAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AAUJ;AARI;EACE,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAUN;AARM;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAUR;AARQ;EACE,yBCvEC;EDwED,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;AAUV;AANM;EACE,kBAAA;EACA,yBCpFI;AD4FZ","sourcesContent":["@import '../../core/styles';\n\n.wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  .button {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 0 10px;\n    height: 40px;\n    border-radius: 8px;\n    border: 1px solid $lightGrey;\n    cursor: pointer;\n    overflow-x: hidden;\n    overflow-y: auto;\n    width: 100%;\n    font-size: 14px;\n    max-width: 500px;\n\n    .crossIconWrapper:after {\n      display: flex;\n      cursor: pointer;\n      background-color: $darkBlue;\n      color: #fff;\n      border-radius: 50%;\n      height: 12px;\n      width: 12px;\n      padding: 2px;\n      font-size: 12px;\n      line-height: 1;\n      text-align: center;\n      vertical-align: middle;\n      content: \"×\";\n      flex-shrink: 0;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .downArrowIcon {\n      height: 20px;\n      width: 20px;\n    }\n  }\n\n  .options {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    top: 100%;\n    left: 0;\n    margin-top: 10px;\n    padding: 10px;\n    background: $white;\n    border-radius: 8px;\n    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n    border: solid 1px $lightGrey;\n    max-height: 200px;\n    z-index: 1;\n    overflow-x: hidden;\n    overflow-y: auto;\n    flex: 1;\n    min-width: 400px;\n\n    .option {\n      line-height: 40px;\n      padding: 0 10px;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      cursor: pointer;\n\n      .checkbox {\n        height: 24px;\n        width: 24px;\n        border: 1px solid $lightGrey;\n        border-radius: 6px;\n        flex-shrink: 0;\n\n        &.active {\n          background-color: $darkBlue;\n          background-image: url(\"../icons/check.svg\");\n          background-repeat: no-repeat;\n          background-position: center;\n          background-size: 9px;\n        }\n      }\n\n      &:hover {\n        border-radius: 8px;\n        background-color: $lightBlue;\n      }\n    }\n  }\n}","@font-face {\n  font-family: 'WhyteInktrap';\n  src: url('./../assets/fonts/ABCWhyteInktrap-Book.otf') format('opentype');\n}\n\n//FONTS\n$mainFont: 'Inter', sans-serif;\n$secondaryFont: 'WhyteInktrap', sans-serif;\n\n// COLORS\n$lightBlue: #DDEAFB;\n$mediumBlue: #B4E1FA;\n$blue: #23A0E5;\n$darkBlue: #60748E;\n$lightGrey: #EAECF0;\n$lightOrange: rgba(250, 182, 145, 0.76);\n$orange: #FF7427;\n$red: #C60C30;\n$plusGreen: #EBFF99;\n$lightGreen: #7ADDAF;\n$green: #007940;\n$darkGreen: #112C22;\n$purple: #D7B7FF;\n$lightPurple: #DBD7FC;\n\n$primaryDark: #222228;\n$secondaryDark: #122D62;\n$white: #FFFFFF;\n\n* {\n  box-sizing: border-box;\n  font-family: $mainFont;\n}\n\nhtml, body {\n  color: $primaryDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MultiSelect_wrapper__cD0am`,
	"button": `MultiSelect_button__jBTWA`,
	"crossIconWrapper": `MultiSelect_crossIconWrapper__AjxRY`,
	"downArrowIcon": `MultiSelect_downArrowIcon__7bQgZ`,
	"options": `MultiSelect_options__mvZTK`,
	"option": `MultiSelect_option__JiksJ`,
	"checkbox": `MultiSelect_checkbox__eI1VO`,
	"active": `MultiSelect_active__kKJe1`
};
export default ___CSS_LOADER_EXPORT___;
